// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const bsn: CountryValidator<"NL"> = createValidator(
  "nl.bsn",
  134,
);

export default bsn;
export const compact = bsn.compact;
export const format = bsn.format;
export const validate = bsn.validate;
export const generate = (): string =>
  bsn.generate?.() ??
  (() => {
    throw new Error(
      "Validator nl.bsn cannot generate values",
    );
  })();
